import { Col, Row } from "antd";
import { useTranslation } from "next-i18next";

function WishlistCom(props) {
  const { title, image } = props.item;
  const count = image.length;
  const { t } = useTranslation("common");

  return (
    <div className="bg-org-30 md:max-w-full max-h-[70%] md:max-h-full  p-4 rounded-2xl cursor-pointer">
      {count <= "1" && (
        <Row justify="center">
          <Col span={24}>
            <img
              src={
                image[0]
                  ? image[0]
                  : "/static/images/about/Aktivreisen-blog_moverii.jpg"
              }
              alt="Not Entered Offer in wish list"
              className="object-cover rounded-2xl md:w-[340px] md:h-[200px] h-60"
            />
          </Col>
        </Row>
      )}
      {count == "2" && (
        <Row justify="space-between" gutter="8">
          <Col span={12}>
            <img
              src={image[0]}
              className="object-cover rounded-l-2xl  md:w-[170px] md:h-[200px] h-60"
            />
          </Col>
          <Col span={12}>
            <img
              src={image[1]}
              className="object-cover rounded-r-2xl md:w-[170px] md:h-[200px] h-60"
              style={{
                borderTopRightRadius: "16px",
                borderBottomRightRadius: "16px",
              }}
            />
          </Col>
        </Row>
      )}
      {count == "3" && (
        <div className="h-[300] grid grid-cols-2 gap-x-2">
          <div className={"md:h-[200px]"}>
            <img
              src={image[0]}
              className="object-cover rounded-l-2xl md:w-[170px] md:h-full h-60"
            />
          </div>
          <div className={"col-span-1 grid grid-rows-2 gap-y-2"}>
            <div className="rounded-tl-2xl row-span-1">
              <img
                src={image[1]}
                className="object-cover  md:w-[170px] h-full "
                style={{
                  borderTopRightRadius: "16px",
                }}
              />
            </div>
            <div className="rounded-tl-2xl row-span-1">
              <img
                src={image[2]}
                className="object-cover rounded-bl-2xl  md:w-[170px]  h-full"
                style={{
                  borderBottomRightRadius: "16px",
                  borderBottomLeftRadius: "0px",
                }}
              />
            </div>
          </div>
        </div>
      )}
      {count >= "4" && (
        <div className="h-[200px] grid grid-cols-2 gap-x-2">
          <div className={"col-span-1 grid grid-rows-2 gap-y-2 h-[200px]"}>
            <div className="rounded-tl-2xl row-span-1">
              <img
                className="object-cover rounded-tl-2xl md:w-[170px] h-full"
                src={image[0]}
                style={{
                  borderTopLeftRadius: "16px",
                }}
              />
            </div>
            <div className=" row-span-1 rounded-bl-2xl">
              <img
                className="object-cover rounded-bl-2xl md:w-[170px] h-full"
                src={image[1]}
                style={{
                  borderBottomLeftRadius: "16px",
                }}
              />
            </div>
          </div>
          <div className={"col-span-1 grid grid-rows-2 gap-y-2 h-[200px]"}>
            <div className=" rounded-tr-2xl row-span-1">
              <img
                className="object-cover rounded-tr-2xl md:w-[170px] h-full"
                src={image[2]}
                style={{
                  borderTopRightRadius: "16px",
                }}
              />
            </div>
            <div className=" rounded-br-2xl row-span-1">
              <img
                className="object-cover rounded-br-2xl md:w-[170px] h-full"
                src={image[3]}
                style={{
                  borderBottomRightRadius: "16px",
                }}
              />
            </div>
          </div>
        </div>
      )}
      <Row>
        <h2 className="text-xl leading-8 font-semibold text-grayDark2 pt-[12px]">
          {title}
        </h2>
      </Row>
      <Row>
        <p className="leading-4 text-base">
          {count}{" "}
          {count === 1
            ? t("wishlist.journey")
            : count === 0
            ? t("wishlist.journeys2")
            : t("wishlist.journeys2")}
        </p>
      </Row>
    </div>
  );
}

export default WishlistCom;
